import { AssigneeDropdownCnt } from 'components/AllDialogs/tasks/createTask/createTask.style';
import { useContext } from 'react';
import { CreateTaskContext } from 'components/AllDialogs/tasks/createTask/context/context';
import CreateEditTaskAssigneeDropdown from 'components/common/jsxrender/task/CreateEdit/CreateEditAssigneeDropdown';

const TaskAssigneeDropdown = () => {
  const { updateTask, newTask } = useContext(CreateTaskContext);

  const handleUpdateAssignee = (assignees) => {
    updateTask({
      assignees,
      isMultiTasks:
        assignees?.length < 2 ? false : newTask?.isMultiTasks || false,
    });
  };

  const handleAutoTagLocation = (isAutoTagLocation: boolean) => {
    updateTask({
      isAutoTagLocation,
      ...(isAutoTagLocation && {
        locationIds: null,
        AssetId: null,
      }),
    });
  };

  return (
    <AssigneeDropdownCnt>
      <label>Assignee:</label>
      <CreateEditTaskAssigneeDropdown
        handleChangeCallback={handleUpdateAssignee}
        assignees={newTask?.assignees || []}
        task={newTask}
        autoTagLocation={{
          show: true,
          onChangeAutoTag: handleAutoTagLocation,
          isAutoTagLocation: newTask?.isAutoTagLocation,
        }}
      />
    </AssigneeDropdownCnt>
  );
};

export default TaskAssigneeDropdown;
